import React from 'react'
import { Select, Input, InputNumber } from 'antd'
import {IBestDataset, IPlotVariable} from '../../../../../../types/analytics'
import { Label } from "../../../../../common/Label/Label"
import styles from '../../../../ResultPanel/Style/LayoutPanel.module.scss'
import PersistenceAdditionalContent from './PersistenceAdditionalContent'

interface PersistenceAdditionalInputProps {
  sign: string
  percentile: number
  duration: number
  threshold: string
  dataset2: string | null
  variablesY: IPlotVariable[] | null
  variableY: any
  sign2: string
  threshold2: string
  categories: string[]
  categoryDataset: IBestDataset[]
  conditionalDSSelected: boolean
  IsChangeDatasetConditional: boolean
  onSignChange: (value: string) => void
  onPercentileChange: (value: number) => void
  onDurationChange: (value: number | null) => void
  onThresholdChange: (e: React.ChangeEvent<HTMLInputElement>) => void
  onDataset2Change: (value: string) => void
  onVariableYChange: (value: number) => void
  onSign2Change: (value: string) => void
  onThreshold2Change: (e: React.ChangeEvent<HTMLInputElement>) => void
  isLoading: boolean
}

export default function PersistenceAdditionalInput({
   sign,
   percentile,
   duration,
   threshold,
   dataset2,
   variablesY,
   variableY,
   sign2,
   threshold2,
   categories,
   categoryDataset,
   conditionalDSSelected,
   IsChangeDatasetConditional,
   onSignChange,
   onPercentileChange,
   onDurationChange,
   onThresholdChange,
   onDataset2Change,
   onVariableYChange,
   onSign2Change,
   onThreshold2Change,
   isLoading,
  }: PersistenceAdditionalInputProps) {
  return (
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      padding: '16px',
      gap: '12px',
      height: '100%'
    }}>
      <Label label="Sign" className={styles.actionItem}>
        <Select
          id="Analytics-Persistence-Sign_Input"
          value={sign}
          size="small"
          style={{ width: '100%' }}
          onChange={onSignChange}
          disabled={isLoading}
        >
          <Select.Option value="below">Below</Select.Option>
          <Select.Option value="above">Above</Select.Option>
        </Select>
      </Label>

      <Label label="Percentile" className={styles.actionItem}>
        <Select
          id="Analytics-Persistence-Percentile_Input"
          value={percentile}
          size="small"
          style={{ width: '100%' }}
          onChange={onPercentileChange}
          disabled={isLoading}
        >
          {[5, 10, 20, 25, 50, 75, 80, 90, 95].map((item, index) => (
            <Select.Option key={index} value={item}>
              {item}
            </Select.Option>
          ))}
        </Select>
      </Label>

      <Label label="Duration [hours]" className={styles.actionItem}>
        <InputNumber
          id="Analytics-Persistence-Duration_Input"
          value={duration}
          onChange={onDurationChange}
          disabled={isLoading}
          size="small"
          style={{ width: '100%' }}
        />
      </Label>

      <Label
        label="Threshold(s) (up to 6 values, comma separated)"
        className={styles.actionItem}
      >
        <Input
          id="Analytics-Persistence-Threshold_Input"
          size="small"
          style={{ width: '100%' }}
          value={threshold}
          onChange={onThresholdChange}
          disabled={isLoading}
        />
      </Label>

      <Label label="Conditional Dataset" className={styles.actionItem}>
        <Select
          id="Analytics-Persistence-Dataset2_Input"
          value={dataset2}
          size="small"
          style={{ width: '100%' }}
          onChange={onDataset2Change}
          disabled={IsChangeDatasetConditional || isLoading}
        >
          <Select.Option key="none" value="">
            None
          </Select.Option>
          {categories.map((category: string) => (
            <Select.OptGroup key={category} label={category}>
              {categoryDataset
                .filter((item) => item.label === category)
                .map((item) => (
                  <Select.Option key={item.id} value={item.id}>
                    {item.value}
                  </Select.Option>
                ))}
            </Select.OptGroup>
          ))}
        </Select>
      </Label>

      {conditionalDSSelected && (
        <>
          <Label label="Variable Y" className={styles.actionItem}>
            <Select
              id="Analytics-Persistence-VariableY_Input"
              value={variableY?.Index ? variableY.Index : 0}
              size="small"
              style={{ width: '100%' }}
              onChange={onVariableYChange}
              disabled={isLoading}
            >
              {variablesY?.map((item) => (
                <Select.Option key={item.Index} value={item.Index}>
                  {item.Name}
                </Select.Option>
              ))}
            </Select>
          </Label>

          <Label label="Sign" className={styles.actionItem}>
            <Select
              id="Analytics-Persistence-Sign2_Input"
              value={sign2}
              size="small"
              style={{ width: '100%' }}
              onChange={onSign2Change}
              disabled={isLoading}
            >
              <Select.Option value="below">Below</Select.Option>
              <Select.Option value="above">Above</Select.Option>
            </Select>
          </Label>

          <Label label="Threshold (1 value)" className={styles.actionItem}>
            <Input
              id="Analytics-Persistence-Threshold2_Input"
              size="small"
              disabled={isLoading}
              value={threshold2}
              onChange={onThreshold2Change}
            />
          </Label>
        </>
      )}

      <PersistenceAdditionalContent />

      <div style={{ flex: 1 }} />
    </div>
  )
}
